import { v4 as uuid } from 'uuid';

const connect = (port, ip, tcpPort, identifier) => {
  logger.debug(
    `[@fingermarkglobal/protocols][tcp]: creating tcp connection to [${ip}] in port [${tcpPort}]`,
  );

  port.postMessage({
    method: 'create',
    tcpPort,
    ip,
    id: identifier,
    topic: 'request/tcp',
  });

  logger.debug(`[@fingermarkglobal/protocols][tcp]: tcp connection created`);
};

const disconnect = (port, handler) => {
  const identifier = uuid();

  logger.debug(`[@fingermarkglobal/protocols][tcp]: disconnecting port`);

  port.onMessage.removeListener(handler);

  port.postMessage({
    method: 'clear',
    id: identifier,
    topic: 'request/tcp',
  });

  logger.debug(`[@fingermarkglobal/protocols][tcp]: port disconnected`);
};

const send = (payload, port, socket, handler) => {
  const identifier = uuid();

  logger.info(`[@fingermarkglobal/protocols] TCP: send [${payload}]`);

  if (!socket) {
    disconnect(port, handler);
    throw new Error('Socket not defined');
  }

  port.postMessage({
    method: 'write',
    socket,
    payload,
    id: identifier,
    topic: 'request/tcp',
  });

  logger.debug(`[@fingermarkglobal/protocols][tcp]: message sent`);
};

const addListener = (port, handler) => {
  logger.debug(`[@fingermarkglobal/protocols][tcp]: adding listener to port`);

  port.onMessage.addListener(handler);
};

export { send, disconnect, addListener, connect };
